<template>
	<div>
		<div class="vx-row">
			<div :class="vx_col_class" v-for="(v, index) in additionalFieldsBasics" :key="index">
				<label
					class="g-label"
					v-if="
						v.type.findWords(
							'number',
							'text',
							'email',
							'url',
							'select',
							'date',
							'location',
							'location_default',
							'check'
						)
					"
					>{{ v.label | capitalize
					}}<label class="g-label" v-if="v.type === 'location' || v.type === 'location_default'"
						>( {{ $t("MapModule.Latitude") }} , {{ $t("MapModule.Longitude") }} )</label
					>
					<label class="font-bold text-danger">{{ v.required ? "*" : "" }}</label>
				</label>
				<vs-input
					v-if="v.type.findWords('number', 'text', 'email')"
					:type="v.type"
					class="w-full"
					v-model="additionalInfo[v.name]"
					v-validate="
						v.type === 'numeric'
							? 'required|numeric'
							: v.type === 'text'
							? 'required'
							: v.type === 'email'
							? 'required|email'
							: 'required'
					"
					:name="v.name"
					:ref="v.name"
				/>

				<vx-input-group v-if="v.type.findWords('location') || v.type.findWords('location_default')">
					<vs-input
						type="text"
						class="w-full"
						v-model="additionalInfo[v.name]"
						:placeholder="
							v.type.findWords('location_default')
								? 'E.g 4.182280, -55.598677'
								: 'E.g 6.182280, -75.598677'
						"
						:v-validate="v.required ? 'required' : 'required'"
						:name="v.name"
						:ref="v.name"
					/>
					<template slot="append">
						<div class="append-text btn-addon">
							<vs-button
								color="primary"
								icon-pack="feather"
								icon="icon-plus"
								:title="$t('Add') + ' ' + $t('MapModule.Coordinates')"
								@click="openMap(v.name)"
							></vs-button>
						</div>
					</template>
				</vx-input-group>

				<vx-input-group v-if="v.type.findWords('url')">
					<vs-input
						:type="v.type"
						v-model="additionalInfo[v.name]"
						v-validate="'url:require_protocol|required'"
						:name="v.name"
						:ref="v.name"
					/>

					<template slot="append">
						<div class="append-text btn-addon">
							<vs-button
								:disabled="errors.has(v.name) || !additionalInfo[v.name]"
								color="primary"
								@click="openUrl(additionalInfo[v.name])"
								>{{ $t("Go") }}
							</vs-button>
						</div>
					</template>
				</vx-input-group>

				<datepicker
					v-if="v.type.findWords('date')"
					:name="v.name"
					:value="datepikerValue(additionalInfo[v.name])"
					@input="datepickerChange($event, v)"
					class="w-full"
				></datepicker>

				<v-select
					v-if="v.type.findWords('select')"
					v-model="additionalInfo[v.name]"
					:clearable="false"
					@change="errors.clean()"
					:options="getPropertyOptions(v.options)"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
				>
					<template v-slot:no-options="{search, searching}">
						<template v-if="searching">
							{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
						</template>
					</template>
				</v-select>

				<v-select
					v-if="v.type.findWords('check')"
					v-model="additionalInfo[v.name]"
					:clearable="false"
					@change="errors.clean()"
					:options="v.options"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					multiple
				>
					<template v-slot:no-options="{search, searching}">
						<template v-if="searching">
							{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
						</template>
					</template>
				</v-select>
				<!-- Messages -->
				<span v-if="v.type.findWords('url')" class="text-danger text-sm" v-show="errors.has(v.name)">{{
					errors.first(v.name)
				}}</span>
				<span
					v-if="v.type.findWords('number', 'text', 'email', 'date')"
					class="text-danger text-sm"
					v-show="errors.has(v.name) || v.error"
					>{{ $t("ErrorVariable.Textvariable1") || v.error_message }}</span
				>
			</div>
		</div>
		<div class="vx-row" v-if="renderImgFileInput">
			<div class="vx-col w-full sm:w-1/1 md:w-1/2" v-for="v in additionalFieldsImgFile" :key="v.labe">
				<dinamic-img-field :field="v" :additionalInfo="additionalInfo" :label="v.label | capitalize" />
			</div>
		</div>

		<!-- MAP COMPONENT -->
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="formatData.cx === 0 && formatData.cy === 0 ? false : true"
			:title="vsPopupTitle"
			:active.sync="popupMapMounted"
		>
			<div class="vx-row">
				<div :class="formatData.cx === 0 && formatData.cy === 0 ? 'vx-col w-full' : 'vx-col w-full md:w-1/2'">
					<vx-card no-shadow card-border>
						<vs-alert color="success" vs-icon="new_releases" class="mb-2" :active.sync="geoAlert">
							{{ $t("Routing.FromMapTitle") }}
						</vs-alert>
						<popup-map
							v-if="popupMapMounted"
							:name="mapConfig.name"
							:latitude="mapConfig.latitude"
							:longitude="mapConfig.longitude"
							:zoom="mapConfig.zoom"
							:theme="mapConfig.theme"
							:calledFrom="mapConfig.calledFrom"
							:changeCursorEnable="true"
							:getCallbackClick="callbackClick"
							:getCoordinatesDrag="getCoordinatesDrag"
							@getInstanceMapEmit="getInstanceMap"
						></popup-map>
					</vx-card>
				</div>
				<div v-if="formatData.cx !== 0 && formatData.cy !== 0" class="vx-col w-full md:w-1/2">
					<vx-card no-shadow card-border>
						<form class="form-content">
							<vs-alert
								color="success"
								closable
								icon-pack="feather"
								close-icon="icon-x"
								:active.sync="geoAlertAddress"
							>
								{{
									$t("MapModule.GeoreferencingByAddress") +
									" " +
									$t("Groups.ClickOnButton").toLocaleLowerCase() +
									" " +
									$t("MapModule.Georeference").toLocaleLowerCase()
								}}
								<feather-icon svgClasses="h-4 w-4" icon="GlobeIcon" />
								{{
									$t("MapModule.DiscardTheChanges").toLocaleLowerCase() +
									" " +
									$t("Groups.ClickOnButton").toLocaleLowerCase() +
									" " +
									$t("Cancel").toLocaleLowerCase()
								}}
								<feather-icon svgClasses="h-4 w-4" icon="XIcon" />
							</vs-alert>
							<div class="vx-row">
								<div class="vx-col w-full">
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ $t("Address") }}</label>
											<vx-input-group>
												<vs-input
													v-model="formatData.address"
													name="item-address"
													v-validate="'required'"
													:disabled="isDisabled"
													@change="(showGeoAgain = true), (isDisabled = false)"
												/>
												<template slot="append">
													<div class="append-text btn-addon">
														<vs-button
															v-if="!isDisabled"
															color="warning"
															icon-pack="feather"
															icon="icon-x"
															:title="$t('Cancel')"
															@click.prevent="cancelAction"
														></vs-button>
														<vs-button
															v-if="!isDisabled"
															color="primary"
															icon-pack="feather"
															icon="icon-globe"
															:title="$t('MapModule.GeoCoordinates')"
															@click.prevent="geoCoder"
														></vs-button>
														<vs-button
															v-else
															:title="$t('Edit') + ' ' + $t('Address')"
															icon-pack="feather"
															icon="icon-edit"
															@click.prevent="
																(isDisabled = !isDisabled),
																	(geoAlertAddress = true),
																	(showButtonAddCoordinates = false)
															"
														/>
													</div>
												</template>
											</vx-input-group>
											<span class="text-danger text-sm" v-show="errors.has('item-address')">{{
												$t("GroupValidMessages.ItemAddress")
											}}</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ $t("Country") }}</label>
											<v-select
												v-model="dataCountry"
												v-validate="'required'"
												name="country"
												:clearable="false"
												:disabled="
													formatData.address === '' ||
													formatData.address === null ||
													formatData.address === undefined
												"
												:options="countriesOptions"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
											<span class="text-danger text-sm" v-show="errors.has('country')"
												>{{ $t("VisitPointObject.Create.ValidMessages.Country") }}
											</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ $t("Department") }}</label>
											<v-select
												v-model="selectedDepartment"
												name="departments"
												:loading="departments.length <= 0 && dataCountry ? true : false"
												:clearable="false"
												:disabled="
													departments.length <= 0 ||
													formatData.address === '' ||
													formatData.address === null ||
													formatData.address === undefined ||
													isDisabled
												"
												:options="departments"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
											<span class="text-danger text-sm" v-show="errors.has('departments')"
												>{{ $t("VisitPointObject.Create.ValidMessages.Departament") }}
											</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col w-full">
											<label class="vs-input--label">{{ $t("City") }}</label>
											<v-select
												v-model="dataCity"
												v-validate="'required'"
												name="cities"
												:loading="
													cities.length <= 0 && selectedDepartment && dataCountry
														? true
														: false
												"
												:clearable="false"
												:disabled="
													cities.length <= 0 ||
													formatData.address === '' ||
													formatData.address === null ||
													formatData.address === undefined ||
													isDisabled
												"
												:options="cities"
												:dir="$vs.rtl ? 'rtl' : 'ltr'"
											>
												<template v-slot:no-options="{search, searching}">
													<template v-if="searching">
														{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
													</template>
												</template>
											</v-select>
											<span class="text-danger text-sm" v-show="errors.has('cities')"
												>{{ $t("VisitPointObject.Create.ValidMessages.City") }}
											</span>
										</div>
									</div>
									<div class="vx-row mb-4">
										<div class="vx-col md:w-1/2 w-full">
											<vs-input
												class="w-full"
												:label="$t('MapModule.Latitude')"
												v-model="formatData.cy"
												name="cy"
												disabled
											/>
											<span class="text-danger text-sm" v-show="errors.has('cy')">{{
												errors.first("cy")
											}}</span>
										</div>
										<div class="vx-col md:w-1/2 w-full">
											<vs-input
												class="w-full"
												:label="$t('MapModule.Longitude')"
												v-model="formatData.cx"
												name="cx"
												disabled
											/>
											<span class="text-danger text-sm" v-show="errors.has('cx')">{{
												errors.first("cx")
											}}</span>
										</div>
									</div>
								</div>
							</div>
						</form>
					</vx-card>
				</div>
			</div>
			<div v-if="formatData.cx !== 0 && formatData.cy !== 0 && showButtonAddCoordinates" class="vx-row">
				<div class="vx-col w-full mt-2">
					<div class="flex flex-wrap items-center justify-end">
						<vs-button
							color="success"
							:disabled="formatData.cx === 0 || formatData.cy === 0"
							@click="confirmCoordinates(formatData)"
							>{{ $t("Add") + " " + $t("MapModule.Coordinates") }}
						</vs-button>
					</div>
				</div>
			</div>
		</vs-popup>
	</div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import DateUtils from "@/helpers/DateUtils.js";
import Resource from "@/models/Resource.js";
import DinamicImgField from "./DinamicImgField.vue";
import PopupMap from "@/components/calendar/PopupMap.vue";
import FormGeo from "@/components/zonification/FormGeo";
import Commons from "@/helpers/commons.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import User from "@/models/User.js";
import moduleCompany from "@/store/company/moduleCompany.js";
import phonesSuccess from "@/assets/images/markers/phones_success.png";
import {mapFeatures} from "@/plugins/mapFeatures";
import ManageErrorMessages from "@/models/ManageErrorMessages";

export default {
	components: {
		FormGeo,
		vSelect,
		Datepicker,
		DinamicImgField,
		PopupMap,
	},
	props: {
		additionalFields: {
			type: Array,
			required: true,
		},
		additionalInfo: {
			type: Object,
			required: true,
		},
		category: {
			type: Object,
			required: true,
		},
		vx_col_class: {
			type: String,
			default: "vx-col w-full sm:w-1/1 md:w-1/2 mb-4",
		},
		renderImgFileInput: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			additional_info: {},
			popupMapMounted: false,
			mapConfig: {
				name: "popup-map",
				latitude: 0,
				longitude: 0,
				zoom: "13",
				theme: "uber",
				calledFrom: "DinamicFields",
			},
			formatData: {
				country: "",
				department: "",
				city: "",
				address: "",
				addressOld: "",
				cx: 0,
				cy: 0,
			},
			locationPropSelected: "",
			geoAlert: false,
			geoAlertAddress: false,
			showGeoAgain: false,
			dataCity: null,
			dataCountry: null,
			selectedDepartment: null,
			departments: [],
			countries: [],
			cities: [],
			userSession: new User(),
			isDisabled: true,
			marker: null,
			manageErrorMessages: new ManageErrorMessages({that: this}),
			showButtonAddCoordinates: true,
		};
	},
	watch: {
		dataCity(val) {
			if (val) {
				this.formatData.city = typeof val === "object" ? val.value : val;
			}
		},
		dataCountry(val) {
			if (val === null || val === undefined) {
				return;
			}
			this.formatData.country = typeof val === "object" ? val.value : val;
			this.getDepartments(val.label);
		},
		selectedDepartment(val) {
			if (val === null || val === undefined) {
				return;
			}
			this.formatData.department = typeof val === "object" ? val.value : val;
			this.getCities(val.value);
		},
	},
	computed: {
		getPropertyOptions() {
			return function (options) {
				return options.map(({value}) => value);
			};
		},
		datepikerValue() {
			return function (params) {
				if (params) {
					return new Date(`${params} 00:00:00`);
				}
			};
		},
		additionalFieldsBasics() {
			return this.additionalFields.filter((field) => field.type !== "img" && field.type !== "file");
		},
		additionalFieldsImgFile() {
			return this.additionalFields.filter((field) => field.type === "img" || field.type === "file");
		},
		vsPopupTitle() {
			return `${this.$t("Select")} ${this.$t("Routing.Point")}`;
		},
		countriesOptions() {
			return Commons.generateSelectOptios(
				this.$store.state.moduleCommon.countries_sitidata,
				"country_name",
				"country_name"
			);
		},
		async getCountryCompany() {
			const user = await this.userSession.getUser();
			return this.$store
				.dispatch("moduleCompany/getCompanyId", user.company_id)
				.then((res) => res)
				.catch((error) => console.error(error));
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		datepickerChange($event, v) {
			this.additional_info[v.name] = DateUtils.toDefaultDateTime($event, "YYYY-MM-DD");
		},
		openUrl(object) {
			window.open(object);
		},
		getAddionalInfo() {
			// Validamos y formateamos todas las propiedades adicionales
			// Combinando en un objeto las nuevas y las recibidas en props
			const res = new Resource({});
			const newAdditionalInfo = res.validateAdditionalPropertie(
				{category: this.category},
				{...this.additionalInfo, ...this.additional_info}
			);
			return newAdditionalInfo;
		},
		async callbackClick(markerEvent) {
			if (this.dataCountry !== null) {
				this.geoReverse({
					country: this.dataCountry || this.dataCountry.value,
					cy: markerEvent.lat,
					cx: markerEvent.lng,
				});
				this.map.removeMarker(this.marker);
				this.marker = this.map.addMarkerToMap(
					{cy: markerEvent.lat, cx: markerEvent.lng},
					{
						icon: phonesSuccess,
						draggable: true,
						onDragend: (coords) => {
							this.geoReverse({
								country: this.dataCountry || this.dataCountry.value,
								cy: coords.lat,
								cx: coords.lng,
							});
						},
					}
				);
			} else {
				this.getCountryCompany
					.then((res) => {
						this.geoReverse({
							country: res.data[0]["country"],
							cy: markerEvent.lat,
							cx: markerEvent.lng,
						});
						this.map.removeMarker(this.marker);
						this.marker = this.map.addMarkerToMap(
							{
								cy: markerEvent.lat,
								cx: markerEvent.lng,
							},
							{
								icon: phonesSuccess,
								draggable: true,
								onDragend: (coords) => {
									this.geoReverse({
										country: res.data[0]["country"],
										cy: coords.lat,
										cx: coords.lng,
									});
								},
							}
						);
					})
					.catch((error) => console.error(error));
			}
		},
		getCoordinatesDrag(markerEvent) {
			if (this.dataCountry !== null) {
				this.geoReverse({
					country: this.dataCountry || this.dataCountry.value,
					cy: markerEvent.lat,
					cx: markerEvent.lng,
				});
			} else {
				this.getCountryCompany
					.then((res) => {
						this.geoReverse({
							country: res.data[0]["country"],
							cy: markerEvent.lat,
							cx: markerEvent.lng,
						});
					})
					.catch((error) => console.error(error));
			}
		},
		openMap(propertyName) {
			if (
				this.additionalInfo[propertyName] !== undefined &&
				this.additionalInfo[propertyName] !== null &&
				this.additionalInfo[propertyName] !== ""
			) {
				const divideCoordinates = this.additionalInfo[propertyName].split(",");
				const coordinates = {
					lat: divideCoordinates[0],
					lng: divideCoordinates[1],
				};
				this.mapConfig.latitude = parseFloat(coordinates.lat);
				this.mapConfig.longitude = parseFloat(coordinates.lng);
				this.formatData.cy = 0;
				this.formatData.cx = 0;
				this.showGeoAgain = false;
			}
			this.isDisabled = true;
			this.popupMapMounted = true;
			this.locationPropSelected = propertyName;
			this.geoAlert = true;
		},
		/**
		 * ! Esta funcion es pasada como propiedad e invocada desde el componente form-geo
		 * TODO: Recuperar y guardar los valores obtenidos de la georreferenciacion
		 * @param { String } address
		 * @param { String } city
		 * @param { Number } cx float number Eg -73.87575657
		 * @param { Number } cy float number Eg  3.8735575657
		 */
		setDataGeo({address, city, cx, cy}) {
			this.formatData = {
				address,
				city,
				cy,
				cx,
			};
		},
		/**
		 * ! Esta funcion es pasada como propiedad e invocada desde el componente form-geo
		 * TODO: Mostrar la alerta acorde a la respuesta del georrefenciador
		 */
		showDataGeoAlert(text, color) {
			this.geoAlert = true;
			if (color === "danger") {
				this.formatData.cy = 0;
				this.formatData.cx = 0;
			}
		},
		confirmCoordinates(data) {
			this.additionalInfo[this.locationPropSelected] = `${(+data.cy).toFixed(8)},${(+data.cx).toFixed(8)}`;
			this.popupMapMounted = false;
		},
		getDepartments(countryName) {
			this.$store
				.dispatch("moduleCommon/getDepartments", {name: countryName})
				.then((res) => {
					this.departments = Commons.generateSelectOptios(res.data, "department_name", "department_name");
				})
				.catch((error) => {
					console.error(error);
				});
		},
		getCities(departmentName) {
			this.$store
				.dispatch("moduleCommon/getCitiesByDeparment", {
					name: departmentName,
					country: this.formatData.country,
				})
				.then((res) => {
					this.cities = Commons.generateSelectOptios(res.data, "city_name", "city_name");
				})
				.catch((error) => {
					console.error(error);
				});
		},
		geoReverse({country, cy, cx}) {
			this.isDisabled = true;
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geoinverso", {country, cy, cx})
				.then((res) => {
					this.closeLoading();
					if (res.data.address1 !== this.formatData.address) {
						this.formatData.cy = cy.toFixed(8);
						this.formatData.cx = cx.toFixed(8);
						this.formatData.address = res.data.address1;
						this.formatData.addressOld = res.data.address1;
						this.dataCountry = country;
						this.selectedDepartment = res.data.department1;
						this.dataCity = res.data.city1;
						this.showButtonAddCoordinates = true;
						this.geoAlertAddress = false;
						//this.showGeoAgain = true
					}
					if (res.status === 200 && res.data.status === "C") {
						this.activePrompt = false;
						this.$vs.notify({
							color: "warning",
							title: this.$t("VisitPointObject.Create.ErrorFindAddress.Title"),
							text:
								this.$t("VisitPointObject.Create.ErrorFindAddress.Text") +
								", " +
								this.$t("VisitPointObject.Create.ErrorFindCountry.Text"),
							time: 7000,
						});
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					throw new Error(err);
				});
		},
		geoCoder() {
			const {country, city, address} = this.formatData;
			if (address === null || address === undefined || address === "") {
				this.$vs.notify({
					color: "warning",
					title: this.$t("VisitPointObject.Create.MissingAddress.Title"),
					text: this.$t("VisitPointObject.Create.MissingAddress.Text"),
				});
				return;
			}
			this.openLoading();
			this.$store
				.dispatch("moduleMap/geocoder", {country, city, address})
				.then((res) => {
					this.closeLoading();
					if (res.status !== 200) {
						throw new Error("Not georreferencer address");
					}
					if (res.status === 200 && res.message === "Procesado y no ubicado.") {
						this.$vs.notify({
							color: "warning",
							title: this.$t("MapModule.Georeferencer"),
							text: this.$t("ManualData.AddressCouldBeNotGeoreferenced"),
						});
						return;
					}
					if (res.status === 200 && res.message === "Geocodificacion Exitosa.") {
						this.dataGeo = {...res.data};
						this.formatData.cy = parseFloat(this.dataGeo.latitude);
						this.formatData.cx = parseFloat(this.dataGeo.longitude);
						this.formatData.cy.toFixed(8);
						this.formatData.cx.toFixed(8);
						this.geoAlertAddress = false;
						this.showButtonAddCoordinates = true;
						if (this.dataGeo.latitude !== "0" || this.dataGeo.longitude !== "0") {
							this.$vs.notify({
								color: "success",
								title: this.$t("VisitPointObject.Create.FindAddress.Title"),
								text: this.$t("VisitPointObject.Create.FindAddress.Text"),
							});
							this.showGeoAgaing = true;
							this.map.removeMarker(this.marker);
							this.marker = this.map.addMarkerToMap(this.formatData, {
								icon: phonesSuccess,
								draggable: true,
								onDragend: (coords) => {
									this.geoReverse({
										country: country,
										cy: coords.lat,
										cx: coords.lng,
									});
								},
							});
							this.isDisabled = true;
						} else {
							this.$vs.notify({
								color: "warning",
								title: this.$t("VisitPointObject.Create.ErrorFindAddress.Title"),
								text: this.$t("VisitPointObject.Create.ErrorFindAddress.Text"),
							});
						}
					}
				})
				.catch((err) => {
					this.closeLoading();
					this.manageErrorMessages.processError(err);
					console.error(err);
				});
		},
		getInstanceMap(data) {
			const map = data.map;
			this.marker = data.marker;
			this.map = new mapFeatures(map);
		},
		cancelAction() {
			this.formatData.address = this.formatData.addressOld;
			this.showButtonAddCoordinates = true;
			this.isDisabled = true;
			this.geoAlertAddress = false;
		},
	},
	filters: {
		capitalize(str = "") {
			return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
		},
	},
	created() {
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}
		if (this.$store.state.moduleCommon.countries_sitidata.length <= 0) {
			this.$store
				.dispatch("moduleCommon/getCountriesByTokenSitiData")
				.then((res) => {
					if (res.data.length === 1) {
						this.dataCountry = res.data[0]["country_name"].toUpperCase();
					}
				})
				.catch((error) => {
					console.error(error);
				});
		}
		String.prototype.findWords = function (...args) {
			var some = args.some((str) => this === str);
			return some;
		};
	},
	beforeDestroy() {
		this.showGeoAgain = false;
	},
};
</script>
